export default "__VITE_ASSET__6940d196__"